import { action, computed, observable, makeObservable } from 'mobx';

import { IUserReaction } from '@gem/models/reactionsModel';

const SHORT_LIST_SIZE = 6;

export class ReactionsStore {
  @observable data: IUserReaction[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed
  get allReactions(): IUserReaction[] {
    return this.data;
  }

  @computed
  get shortReactions(): IUserReaction[] {
    return this.data.slice(0, SHORT_LIST_SIZE);
  }

  getReactionByUnicode(unicode: string): IUserReaction | null {
    return this.data.find((reaction) => reaction.unicode === unicode) || null;
  }

  @action
  setReactions(reactions: IUserReaction[]): void {
    this.data = [...reactions];
  }

  @action
  reset(): void {
    this.data = [];
  }
}
